export const Marquee = ({ items, reverse = false, outline = true }) => {
  const content = [...items, ...items];
  return (
    <div className="relative w-full overflow-hidden border-y border-[#232323] bg-[#050505] py-6">
      <div className={`marquee-track ${reverse ? "reverse" : ""}`}>
        {content.map((it, i) => (
          <span
            key={i}
            className={`font-num text-5xl md:text-7xl leading-none tracking-tight mx-8 ${
              outline ? "text-outline" : "text-[#f4f4f0]"
            }`}
          >
            {it}
            <span className="text-[#ff3300] mx-8">/</span>
          </span>
        ))}
      </div>
    </div>
  );
};
